import {View} from 'MWC';
import tpl from '../templates/Hint.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL
        };

        return this;
    }

    componentDidMount() {}
}
